var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfAsqQuestionBody", {
    staticClass: "ds-question-table",
    class: _vm.getCss,
    attrs: { "show-index": _vm.showIndex, question: _vm._self },
    scopedSlots: _vm._u([
      {
        key: "answer",
        fn: function () {
          return [
            _c(
              "el-form",
              { ref: "form", attrs: { model: _vm.form, "label-width": "0" } },
              [
                _c(
                  "el-table",
                  {
                    ref: "table",
                    attrs: {
                      data: _vm.rowsData,
                      border: "",
                      "header-cell-style": {
                        background: "#f5f7fa",
                        color: "#606266",
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "", align: "center", width: "180" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [_vm._v(" " + _vm._s(scope.row.text) + " ")]
                          },
                        },
                      ]),
                    }),
                    _vm._l(_vm.columns, function (it, index) {
                      return _c("el-table-column", {
                        key: index,
                        attrs: {
                          "min-width": "150",
                          align: "center",
                          label: it.text,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "center",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          staticStyle: { "margin-right": "0" },
                                          attrs: {
                                            disabled:
                                              _vm.readOnly || _vm.disabled,
                                            value: Boolean(
                                              scope.row.model[it.uuid].value
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeCheckbox(
                                                scope,
                                                it
                                              )
                                            },
                                          },
                                        },
                                        [_c("span")]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { position: "relative" },
                                          attrs: {
                                            prop: scope.$index + "," + it.uuid,
                                            rules: _vm.rules,
                                          },
                                        },
                                        [
                                          scope.row.model[it.uuid].value &&
                                          scope.row.setting[it.uuid].isinput
                                            ? _c("el-input", {
                                                attrs: {
                                                  size: "small",
                                                  disabled:
                                                    _vm.readOnly ||
                                                    _vm.disabled,
                                                  maxlength:
                                                    scope.row.setting[it.uuid]
                                                      .limit,
                                                  placeholder: "请输入",
                                                },
                                                model: {
                                                  value:
                                                    scope.row.model[it.uuid]
                                                      .attach,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row.model[it.uuid],
                                                      "attach",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.model[it.uuid].attach",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }